export default {
  nav: {
    brandProducts: 'Prodotti Positive', discover: 'Scopri', allProducts: 'Tutti i prodotti',
    otherProducts: 'Altri prodotti: {count}',
    connectedApps: 'App connesse', currentProduct: 'Sei in {product}',
    openApp: 'Apri {product} in una nuova scheda', discoverProduct: 'Scopri {product}',
  },
  actions: {
    tryFree: 'Prova gratis', discover: 'Scopri', discoverProduct: 'Scopri {product}',
    backToCatalog: 'Torna a tutti i prodotti',
    signIn: 'Accedi', close: 'Chiudi',
  },
  agent: {
    useAssistant: 'Usa nel tuo assistente IA', title: 'Usa {product} nel tuo assistente IA',
    description: 'Collega il tuo assistente a {product} tramite il suo server MCP.',
    other: 'Altro',
    copyPrompt: 'Copia prompt',
    copyDone: 'Copiato', copyRetry: 'Riprova',
    connectTitle: 'Scegli il tuo assistente', connect: 'Collega', availableFor: 'Disponibile per {product}',
    connectionHint: 'Potresti dover accedere e autorizzare l’accesso.',
    permissions: 'Il tuo assistente accede solo ai dati e alle azioni che autorizzi.',
    copy: 'Copia il prompt per collegare il tuo agente a {product}',
    copied: 'Prompt copiato. Incollalo nel tuo agente.', copyError: 'Impossibile copiare il prompt. Riprova.',
  },
  catalog: {
    title: 'Scopri i prodotti Positive', description: 'Strumenti che completano {product}.',
    descriptionDefault: 'Strumenti per i tuoi team di marketing e vendita.', empty: 'Nessun prodotto da scoprire.',
  },
  product: { featuresTitle: 'Cosa puoi fare con {product}' },
  status: { current: 'App attuale', connected: 'App connessa' },
  accessibility: { openMenu: 'Apri la navigazione dei prodotti', newTab: 'Si apre in una nuova scheda' },
  categories: { emailSignatures: 'Firme email', emailing: 'Email marketing', seo: 'SEO & GEO', socialMedia: 'Social media', sales: 'Vendite' },
  products: {
    signitic: {
      tagline: 'Gestione delle firme email',
      description: 'Centralizza tutte le firme email e trasformale in un canale di marketing.',
      features: ['Firme uniformi in tutta l’azienda', 'Campagne banner in ogni email', 'Analisi dei clic e della copertura'],
    },
    user: {
      tagline: 'Email marketing e coinvolgimento dei clienti',
      description: 'Automazione, CRM e chat dal vivo per coinvolgere i tuoi contatti al momento giusto.',
      features: ['Percorsi email e SMS automatizzati', 'CRM per contatti e opportunità', 'Chat dal vivo sul tuo sito'],
    },
    surfer: {
      tagline: 'Ottimizzazione dei contenuti SEO e GEO',
      description: 'Scrivi contenuti che si posizionano su Google e vengono citati dagli assistenti IA.',
      features: ['Brief di contenuto per posizionarsi su Google', 'Citazioni in ChatGPT e nelle risposte IA', 'Scrittura di articoli con IA'],
    },
    iconosquare: {
      tagline: 'Gestione e analisi dei social media',
      description: 'Programma, rispondi e misura le prestazioni di tutti i social network da un’unica piattaforma.',
      features: ['Programmazione dei post su ogni social network', 'Una casella di posta per commenti e messaggi privati', 'Analisi e report'],
    },
    humanlinker: {
      tagline: 'Copilota IA per le vendite',
      description: 'Contatta ogni potenziale cliente in modo personalizzato e trasforma le conversazioni in vendite.',
      features: ['Suggerimenti di potenziali clienti tramite IA', 'Sequenze di contatto personalizzate', 'Preparazione delle riunioni in un clic'],
    },
    ubic: {
      tagline: 'Chiamate in parallelo per i team di vendita',
      description: 'Uno strumento per chiamate in parallelo che permette ai team di vendita di raggiungere più potenziali clienti in meno tempo.',
      features: ['Chiama più potenziali clienti contemporaneamente', 'Ti vengono trasferite solo le chiamate con risposta', 'Sincronizzazione con il tuo CRM'],
    },
    nocrm: {
      tagline: 'Gestione dei lead per i commerciali',
      description: 'Segui ogni lead dal primo contatto alla vendita, senza la complessità di un CRM.',
      features: ['Tutti i lead in un’unica pipeline', 'Promemoria per non perdere opportunità', 'App mobile per il lavoro sul campo'],
    },
  },
};
